import type { Rev2ChartViewKey } from './canonical/rev2ChartViews';

export type BurbankBuildingsElecTab = 'total' | 'res' | 'com' | 'perCapita';

export function burbankElecTabUsesReconciledChart(tab: BurbankBuildingsElecTab): boolean {
  return tab !== 'perCapita';
}

export function burbankElecTabToRev2View(tab: BurbankBuildingsElecTab): Rev2ChartViewKey | null {
  switch (tab) {
    case 'total':
      return 'elec_total';
    case 'res':
      return 'elec_residential';
    case 'com':
      return 'elec_nonresidential';
    default:
      return null;
  }
}
